import { SectionTitle } from "@porchpass/ui";
import { SlideUpModal } from "src/components/SlideUpModal";

type CitizenshipModalProps = {
  isOpen: boolean;
  closeHandler: () => unknown;
};

export default ({ isOpen, closeHandler }: CitizenshipModalProps) => (
  <SlideUpModal
    title="Citizenship Status"
    isOpen={isOpen}
    closeHandler={closeHandler}
    dismissButtonText="Dismiss"
    hasIcon
  >
    <div className="flex flex-col gap-[18px]">
      <div className="flex flex-col gap-[18px]">
        <SectionTitle title="Permanent Resident Alien" size="md" />
        <p className="text-base leading-[22.4px] text-[#111827]">
          Lawful permanent residents (LPRs) are foreign nationals who have been
          granted the right to reside permanently in the United States. LPRs are
          often referred to simply as &#34;immigrants, &#34; but they are also
          known as &#34;permanent resident aliens &#34; and &#34;green card
          holders. &#34;
        </p>
      </div>
      <div className="flex flex-col gap-[18px]">
        <SectionTitle title="Non-Permanent Resident Alien" size="md" />
        <p className="text-base leading-[22.4px] text-[#111827]">
          An alien is any individual who is not a U.S. citizen or U.S. national.
          A nonresident alien is an alien who has not passed the green card test
          or the substantial presence test.
        </p>
      </div>
    </div>
  </SlideUpModal>
);
